import { render, staticRenderFns } from "./ChangeFooterIconText.vue?vue&type=template&id=b1fa73ea&scoped=true"
import script from "./ChangeFooterIconText.vue?vue&type=script&lang=js"
export * from "./ChangeFooterIconText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1fa73ea",
  null
  
)

export default component.exports